export const ComissionTypes = {
  IFilterComissionService: Symbol("IFilterComissionService"),
};
